let swiperInstance;

function initSwiper() {
  const container = document.querySelector(".cart-drawer__upsell.custom .upsell-products.rel");
  if (!container) {
    console.warn("Swiper container not found");
    return;
  }

  // Destroy existing instance
  if (swiperInstance && typeof swiperInstance.destroy === 'function') {
    swiperInstance.destroy(true, true);
  }

  // Initialize new instance
  swiperInstance = new Swiper(".cart-drawer__upsell.custom .upsell-products.rel", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  console.log("Swiper initialized");
}

function updateCartSubtotalUI() {
  const priceHolder = document.querySelector('[data-cart-price-holder]');
  if (!priceHolder) return;

  priceHolder.classList.add('loading');
  const loader = priceHolder.querySelector('.cart__price__loader');
  if (loader) loader.style.display = 'block';

  fetch('/cart.js')
    .then(res => res.ok ? res.json() : Promise.reject(res.status))
    .then(cart => {
      const totalPrice = cart.total_price;
      const formatted = new Intl.NumberFormat("en-PK", {
        style: "currency",
        currency: "PKR"
      }).format(totalPrice / 100);

      const priceSpan = priceHolder.querySelector('[data-cart-total]');
      if (priceSpan) {
        priceSpan.textContent = formatted + " PKR";
        priceSpan.setAttribute("data-cart-total", totalPrice);
      }
    })
    .catch(err => console.error("Failed to update subtotal:", err))
    .finally(() => {
      priceHolder.classList.remove('loading');
      if (loader) loader.style.display = 'none';
    });
}

function refreshCartInnerContent() {
  return fetch("/?sections=cart-drawer")
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    })
    .then(data => {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(data['cart-drawer'], "text/html");

      const newItems = newDoc.querySelector(".drawer__items");
      const newFooter = newDoc.querySelector(".cart__footer");
      const newUpsell = newDoc.querySelector(".cart-drawer__upsell");

      const currentItems = document.querySelector(".drawer__items");
      const currentFooter = document.querySelector(".cart__footer");
      const currentUpsell = document.querySelector(".cart-drawer__upsell");

      if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
      if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
      if (newUpsell && currentUpsell) currentUpsell.innerHTML = newUpsell.innerHTML;

      // Trigger event for reinitialization
      document.dispatchEvent(new CustomEvent("cart:updated"));
    })
    .catch(err => {
      console.error("Failed to refresh cart:", err);
      document.dispatchEvent(new CustomEvent("cart:updated"));
    });
}

function bindCartDrawerButtons() {
  const replaceWithClone = (selector) => {
    document.querySelectorAll(selector).forEach(btn => {
      const clone = btn.cloneNode(true);
      btn.replaceWith(clone);
    });
  };

  replaceWithClone(".cart__quantity-plus");
  replaceWithClone(".cart__quantity-minus");
  replaceWithClone(".cart__item__remove");

  const updateCartQuantity = async (id, quantity) => {
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, quantity })
      });
      await refreshCartInnerContent();
    } catch (err) {
      console.error("Update failed:", err);
    }
  };

  document.querySelectorAll(".cart__quantity-plus").forEach(btn => {
    btn.addEventListener("click", () => {
      const input = btn.closest(".cart__quantity").querySelector(".cart__quantity-field");
      const id = input.dataset.id;
      const qty = Math.max(1, parseInt(input.value) || 1);
      updateCartQuantity(id, qty + 1);
    });
  });

  document.querySelectorAll(".cart__quantity-minus").forEach(btn => {
    btn.addEventListener("click", () => {
      const input = btn.closest(".cart__quantity").querySelector(".cart__quantity-field");
      const id = input.dataset.id;
      const qty = Math.max(1, parseInt(input.value) || 1);

      if (qty <= 1) {
        updateCartQuantity(id, 0); 
      } else {
        updateCartQuantity(id, qty - 1);
      }
    });
  });

  document.querySelectorAll(".cart__item__remove").forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const id = btn.getAttribute("data-id");
      updateCartQuantity(id, 0);
    });
  });
}

function bindQuickViewPopup() {
  document.body.addEventListener("click", async function (e) {
    const quickBtn = e.target.closest(".quick-view");
    if (!quickBtn) return;

    const handle = quickBtn.dataset.handle;
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error("Failed to fetch product");
      const product = await res.json();

      const hasColorVariant = product.options?.some(opt =>
        opt.name.toLowerCase() === 'color'
      );

      const imageHtml = product.images.map(img => `
        <div class="qv-image-slide">
          <img src="${img}" alt="${product.title}" style="max-width:100%;">
        </div>
      `).join('');

      const socialIcons = document.getElementById("social-icons-wrapper")?.innerHTML || '';

      // ✅ Variants handle with stock check
      const variantTabsHtml = product.variants.map((v, i) => {
        const handle = v.title.toLowerCase().replace(/\s+/g, '-');
        const disabled = v.available ? "" : "disabled";
        const soldOutLabel = v.available ? "" : " (sold out)";
        return `
          <button 
            type="button" 
            class="variant-tab ${i === 0 && v.available ? 'active' : ''}" 
            data-id="${v.id}" 
            ${disabled}
            style="background: var(--${handle});">
            ${v.title}${soldOutLabel}
          </button>
        `;
      }).join('');

      // ✅ Agar variants hi nahi hain to default variant ko hide
      const hasVariants = product.variants && product.variants.length > 1;

      const wrapperHtml = `
        <h3 class="qv-title">${product.title}</h3>
        <p class="qv-price">
          Rs.${(product.variants[0].price / 100).toFixed(2)}
          ${product.variants[0].compare_at_price > product.variants[0].price 
            ? `<span class="qv-compare-price">Rs.${(product.variants[0].compare_at_price / 100).toFixed(2)}</span>` 
            : ''}
        </p>
        <div class="qv-desc">${product.description }</div>
        <form id="qv-form">
          ${hasVariants ? `
            <label class="label-qw">Select Option:</label><br>
            <div class="variant-tabs" id="variant-tabs">
              ${variantTabsHtml}
            </div>` : ""}
          <input type="hidden" name="id" id="variant-pr" value="${product.variants.find(v => v.available)?.id || ''}">
          <div class="quantity-wrapper">
            <button type="button" id="qv-minus">–</button>
            <input type="number" id="qv-qty" value="1" min="1">
            <button type="button" id="qv-plus">+</button>
          </div>
          <button type="button" id="qv-add">Add to cart</button>
          <button type="button" id="qv-buy-now">Buy it now</button>
          ${socialIcons}
        </form>`;

      const popup = document.getElementById("quick-view-popup");
      popup.innerHTML = `
        <span class="close-qw" style="cursor:pointer;position:sticky;top:-1px;right:0;font-size:18px;margin-left:auto;">X</span>
        <div class="qv-image">${imageHtml}</div>
        <div class="qv-wrapper">${wrapperHtml}</div>`;

      popup.classList.add("visible");
      document.querySelector(".wrapper-screen")?.classList.add("visible");

      // ✅ disable "Add to Cart" agar selected variant out of stock hai
      const variantInput = document.getElementById("variant-pr");
      const addBtn = document.getElementById("qv-add");
      const buyBtn = document.getElementById("qv-buy-now");

      function toggleButtons() {
        const selectedId = variantInput.value;
        const selectedVariant = product.variants.find(v => v.id == selectedId);
        if (!selectedVariant || !selectedVariant.available) {
          addBtn.disabled = true;
          buyBtn.disabled = true;
        } else {
          addBtn.disabled = false;
          buyBtn.disabled = false;
        }
      }
      toggleButtons();

      const variantTabsContainer = document.getElementById("variant-tabs");
      if (variantTabsContainer) {
        if (hasColorVariant) {
          variantTabsContainer.classList.add('has-color');
          variantTabsContainer.classList.remove('default-has');
        } else {
          variantTabsContainer.classList.remove('has-color');
          variantTabsContainer.classList.add('default-has');
        }
      }

      // document.querySelectorAll("#variant-tabs .variant-tab").forEach(tab => {
      //   tab.addEventListener("click", () => {
      //     if (tab.hasAttribute("disabled")) return;
      //     document.querySelectorAll("#variant-tabs .variant-tab").forEach(t => t.classList.remove("active"));
      //     tab.classList.add("active");
      //     variantInput.value = tab.getAttribute("data-id");
      //     toggleButtons();
      //   });
      // });


      document.querySelectorAll("#variant-tabs .variant-tab").forEach(tab => {
  tab.addEventListener("click", () => {
    if (tab.hasAttribute("disabled")) return;

    // ✅ 1. Handle active state + variant ID
    document.querySelectorAll("#variant-tabs .variant-tab").forEach(t => t.classList.remove("active"));
    tab.classList.add("active");
    variantInput.value = tab.getAttribute("data-id");
    toggleButtons();

    // ✅ 2. Update image slider based on selected variant
    const selectedId = tab.getAttribute("data-id");
    const selectedVariant = product.variants.find(v => v.id == selectedId);

    if (selectedVariant && selectedVariant.featured_image) {
      const newImageUrl = selectedVariant.featured_image.src;

      // ✅ 3. Replace slider content with new image (or variant images if you want multiple)
      const qvImageContainer = document.querySelector(".qv-image");
      if (qvImageContainer) {
        qvImageContainer.innerHTML = `
          <div class="qv-image-slide">
            <img src="${newImageUrl}" alt="${product.title}" style="max-width:100%;">
          </div>
        `;

        // ✅ 4. Re-initialize Slick after replacing content
        if (typeof jQuery !== "undefined" && typeof jQuery.fn.slick === "function") {
          jQuery(qvImageContainer).slick('unslick'); // remove old instance if any
          jQuery(qvImageContainer).slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
          });
        }
      }
    }
  });
});


      setTimeout(() => {
        if (typeof jQuery !== "undefined" && typeof jQuery.fn.slick === "function") {
          $('.qv-image').slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
          });
        }
      }, 500);

    } catch (err) {
      console.error("Popup fetch error:", err);
      alert("Unable to load product data.");
    }
  });

  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("wrapper-screen") || e.target.classList.contains("close-qw")) {
      document.getElementById("quick-view-popup")?.classList.remove("visible");
      document.querySelector(".wrapper-screen")?.classList.remove("visible");
    }

    if (e.target.id === "qv-plus") {
      const input = document.getElementById("qv-qty");
      input.value = Math.max(1, parseInt(input.value) || 1) + 1;
    } else if (e.target.id === "qv-minus") {
      const input = document.getElementById("qv-qty");
      input.value = Math.max(1, (parseInt(input.value) || 1) - 1);
    }

    if (e.target.id === "qv-add" || e.target.id === "qv-buy-now") {
      const variantId = document.getElementById("variant-pr")?.value;
      const quantity = Math.max(1, parseInt(document.getElementById("qv-qty")?.value) || 1);

      if (!variantId) {
        alert("Please select a valid variant.");
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity })
      })
        .then(res => res.ok ? res.json() : Promise.reject(res.status))
        .then(() => {
          document.getElementById("quick-view-popup")?.classList.remove("visible");
          document.querySelector(".wrapper-screen")?.classList.remove("visible");
          return refreshCartInnerContent();
        })
        .then(() => {
          document.dispatchEvent(new CustomEvent("cart:updated"));
        })
        .catch(() => alert("Failed to add item to cart."));
    }
  });
}

// ✅ DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  initSwiper();
  bindCartDrawerButtons();
  bindQuickViewPopup();

  document.body.addEventListener("click", function (e) {
    const isQtyButton = e.target.closest(".cart__quantity-minus, .cart__quantity-plus, .quick-add__button");
    const isRemoveButton = e.target.closest(".cart__item__remove");

    if (isQtyButton || isRemoveButton) {
      const drawerItems = document.querySelector(".drawer__items");
      if (!drawerItems) return;

      const observer = new MutationObserver((mutationsList, obs) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            initSwiper(); 
            obs.disconnect();
            break;
          }
        }
      });

      observer.observe(drawerItems, { childList: true, subtree: true });
    }
  });

  document.body.addEventListener("click", function (e) {
    const productAddBtn = e.target.closest(".product__submit__item .btn");
    if (!productAddBtn) return;

    productAddBtn.disabled = true;

    setTimeout(async () => {
      try {
        await refreshCartInnerContent();
        initSwiper(); 
      } catch (err) {
        console.error("Failed to refresh after add-to-cart:", err);
        initSwiper(); 
      } finally {
        productAddBtn.disabled = false;
      }
    }, 1800);
  });
});

document.addEventListener("cart:updated", () => {
  bindCartDrawerButtons();
  initSwiper();
  updateCartSubtotalUI();
});
